module.exports = __webpack_public_path__ + "media/images/covid/icons/gargle-b0bc55cd16e163146a47c15ff6917679.svg";